import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SlideInterfaceModel } from '../../../../models/slide.model';
import { TableHeaderInterfaceModel } from '../../../../models/table.model';
import { TitleCardModel } from '../../../../models/title-card.model';
import { TopicCardModel } from '../../../../models/topic-card.model';
import { TrainingCategoryModel } from '../../../../models/training-category.model';
import { TrainingCategoryService } from '../../../../services/training-category.service';

@Component({
  selector: 'app-training-categories',
  templateUrl: './training-categories.component.html',
  styleUrl: './training-categories.component.scss',
  standalone: false,
})
export class TrainingCategoriesComponent implements OnInit {
  private seminarCategories: TrainingCategoryModel[];
  public isLoading = true;
  public selectedType: TrainingCategoryModel;
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private courseTypeService: TrainingCategoryService
  ) {}

  public optionMenuItems = [];

  public cardSlides: TableHeaderInterfaceModel[];
  public titleCard: TitleCardModel;
  public slide: SlideInterfaceModel;
  public topicCard: TopicCardModel;
  public slideHeaderNavigation: TableHeaderInterfaceModel;

  public async ngOnInit() {
    await this.getSeminarCategories();

    this.setSelectedCategory(this.seminarCategories[0]);

    this.initOptionMenuItems();

    this.isLoading = false;
  }

  private initOptionMenuItems() {
    this.optionMenuItems = [
      {
        label: 'Fortbildung bearbeiten',
        icon: 'fa-regular fa-pen',
        command: () => {
          this.onEditSeminarCategory();
        },
      },
      {
        label: 'Fortbildung hinzufügen',
        icon: 'fa-regular fa-plus',
        command: () => {
          this.onCreateSeminarCategory();
        },
      },
    ];
    if (this.selectedType?.isDisabled) {
      this.optionMenuItems.push({
        label: 'Kategorie aktivieren',
        icon: 'fa-regular fa-folder-plus',
        command: () => {
          this.onToggleCategory();
        },
      });
    } else {
      this.optionMenuItems.push({
        label: 'Kategorie deaktivieren',
        icon: 'fa-regular fa-folder-minus',
        command: () => {
          this.onToggleCategory();
        },
      });
    }
  }

  public onCreateSeminarCategory() {
    this.router.navigate(['create'], { relativeTo: this.activatedRoute });
  }

  public onEditSeminarCategory() {
    this.router.navigate(['edit', btoa(String(this.selectedType.id))], {
      relativeTo: this.activatedRoute,
    });
  }

  public onToggleCategory() {
    this.courseTypeService
      .toggleSeminarCategory(this.selectedType.id)
      .subscribe({
        next: () => {
          this.selectedType.isDisabled = !this.selectedType.isDisabled;
          this.initOptionMenuItems();
        },
      });
  }

  private async getSeminarCategories(): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.courseTypeService
        .getAllTrainingCategories(true)
        .subscribe(categories => {
          this.seminarCategories = categories;
          if (!categories.length) {
            resolve();
            return;
          }
          this.cardSlides = categories.map(type => ({
            title: type.name,
            details:
              type.courseCount == 1
                ? `${type.courseCount} Seminar`
                : `${type.courseCount} Seminare`,
            color50: type.color50,
            color0: type.color0,
            color70: type.color70,
            color80: type.color80,
            color90: type.color90,
          }));
          this.cardSlides[0].selected = true;
          resolve();
        });
    });
  }

  onCardClicked(event) {
    this.cardSlides = this.cardSlides.map(slide => ({
      ...slide,
      selected: slide.title === event.title,
    }));

    const selectedType = this.seminarCategories.find(
      type => type.name === event.title
    );

    this.setSelectedCategory(selectedType);
    this.initOptionMenuItems();
  }

  private setSelectedCategory(category: TrainingCategoryModel) {
    if (!category) {
      return;
    }
    this.selectedType = category;

    this.topicCard = {
      title: this.selectedType.name,
      subtitle: 'Dr. med. Max Mustermann',
      image: '../../../assets/images/placeholder.svg',
      color50: this.selectedType.color50,
      color0: this.selectedType.color0,
      color70: this.selectedType.color70,
      color80: this.selectedType.color80,
      color90: this.selectedType.color90,
    };

    this.titleCard = {
      title: this.selectedType.name,
      descriptionBold: this.selectedType.descriptionBold ?? '',
      description: this.selectedType.description ?? '',
      image: null,
      color0: this.selectedType.color0,
      color50: this.selectedType.color50,
      color70: this.selectedType.color70,
      color80: this.selectedType.color80,
    };

    this.slide = {
      url:
        this.selectedType.titlePicture ??
        '../../../assets/images/placeholder.svg',
      title: this.selectedType.name,
      color50: this.selectedType.color50,
      color0: this.selectedType.color0,
      color70: this.selectedType.color70,
      color80: this.selectedType.color80,
      color90: this.selectedType.color90,
    };

    this.slideHeaderNavigation = {
      title: this.selectedType.name,
      details:
        this.selectedType.courseCount == 1
          ? `${category.courseCount} Seminar`
          : `${category.courseCount} Seminare`,
      color50: this.selectedType.color50,
      color0: this.selectedType.color0,
      color70: this.selectedType.color70,
      color80: this.selectedType.color80,
      color90: this.selectedType.color90,
    };
  }
}
